export default {
  disclaimer: {
    summary:
      'Please note that it is your responsibility to confirm that any and all currency and taxes are accurate for the applicable jurisdiction.',
    extra:
      'We include this information for your convenience only and assume no responsibility for the accuracy of the currency and/or taxes or for the payment of such taxes as part of our products. Information contained herein related to currency and taxes is for informational purposes only.',
    show_more: 'Show more',
    show_less: 'Show less',
  },
  partner_note:
    'These are your partner-level defaults. Restaurants under your account inherit these values automatically unless they override a category individually.',
  section_title: 'Tax rates for menu items',
  new_category_placeholder: 'New category',
  form: {
    name: {
      label: 'Tax category',
    },
    default_tax_rate: {
      label: 'Default rate',
      tooltip: 'Used as the fallback whenever a specific order-method rate below is left empty.',
    },
    pickup_tax_rate: {
      label: 'Pickup',
    },
    delivery_tax_rate: {
      label: 'Delivery',
    },
    dine_in_tax_rate: {
      label: 'In restaurant',
    },
    room_service_tax_rate: {
      label: 'Room service',
    },
    show_zero_tax_in_summary: {
      label: 'Show 0% tax in order summary',
    },
  },
  buttons: {
    add_category: 'Add new tax category',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Delete',
    delete: 'Delete category',
    reset: 'Reset to inherited',
  },
  delete_confirm: {
    title: 'Delete this tax category?',
    description: 'This cannot be undone.',
  },
  scope_labels: {
    region: 'Region-wide',
    partner: 'Partner-wide',
    restaurant: 'Restaurant-wide',
  },
  confirm_modal: {
    title: {
      fork: "Make it this restaurant's own category?",
      owned: 'Apply the new rates?',
      reset: 'Go back to the inherited category?',
    },
    affected_one: '{{count}} product or category is currently linked and will be charged the new rates.',
    affected_other: '{{count}} products and categories are currently linked and will be charged the new rates.',
    affected_settings_one: '{{count}} product or category is currently linked and will use the updated settings.',
    affected_settings_other:
      '{{count}} products and categories are currently linked and will use the updated settings.',
    restaurants_one: 'That is {{count}} restaurant.',
    restaurants_other: 'That is {{count}} restaurants.',
    acknowledge:
      'I understand that confirming this changes the tax category for all products that are currently linked with this category',
    impact_error: 'Failed to check which products this would change',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  toasts: {
    load_error: 'Could not load the tax categories.',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
    delete_error: 'Could not delete this tax category.',
    category_deleted: 'Tax category deleted',
    category_reset: 'Tax category reset to the inherited one',
    reset_error: 'Could not reset this tax category.',
    impact_error: 'Failed to check which products this would change',
    impact_changed_one: 'The number of affected products changed to {{count}}. Please review and confirm again.',
    impact_changed_other: 'The number of affected products changed to {{count}}. Please review and confirm again.',
  },
};
